import { getDistinctExpiry, getScripLookUp, mutualFundSearch } from "../../apis";
import { BUSINESS_LAYER_RESPONSE, GLOBAL_SEARCH_SCRIPS, WATCHLIST_GRID_INDEX, EXPAND_RECENT_SEARCH_LENGTH, RECENT_SEARCH_LENGTH, LOCAL_STORAGE_KEYS } from "../../utils/global_variables";
import { getDecryptLocalStorage, getStorageWithMultiTabCheck, getDynamicParamsForToFixed } from "../../utils/global_functions";

const getSearchDataAsPerSearchIndexes = (searchScrips, isFill = false) => {
    // This function returns data as per binded in Global Search UI Scrips List
    // searchScrips is Response From API
    const arrSortedSearchIndexes = Object.values(WATCHLIST_GRID_INDEX).sort((a, b) => a - b);
    const arrSearchData = searchScrips?.data?.result?.hits?.hits?.map(eachObj => {
        const arrScripFields = new Array(arrSortedSearchIndexes[arrSortedSearchIndexes.length - 1] + 1).fill(!isFill ? '' : "0.00");
        arrScripFields[WATCHLIST_GRID_INDEX.SEGMENT_ID] = eachObj._source.MktSegId;
        arrScripFields[WATCHLIST_GRID_INDEX.TOKEN] = eachObj._source.nToken;
        arrScripFields[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] = eachObj._source.MktSegId.toString() + '_' + eachObj._source.nToken.toString();
        arrScripFields[WATCHLIST_GRID_INDEX.SYMBOL] = eachObj._source.sSymbol;
        arrScripFields[WATCHLIST_GRID_INDEX.EXCHANGE] = eachObj._source.sExchange;
        arrScripFields[WATCHLIST_GRID_INDEX.INSTRUMENT] = eachObj._source.sInstrumentName;
        arrScripFields[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] = eachObj._source.nMarketSegmentId;
        arrScripFields[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR] = eachObj._source.DecimalLocator;
        arrScripFields[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] = eachObj._source.nMarketSegmentId;
        arrScripFields[WATCHLIST_GRID_INDEX.SERIES] = eachObj._source.sSeries;
        arrScripFields[WATCHLIST_GRID_INDEX.NSPREAD] = eachObj?._source?.nSpread;
        arrScripFields[WATCHLIST_GRID_INDEX.EXPIRYDATE] = eachObj?._source?.nExpiryDate1;
        //By HiralK : 05-08-2023 - To resolve Search Description issue - Start
        arrScripFields[WATCHLIST_GRID_INDEX.STRIKEPRICE] = eachObj?._source?.nStrikePrice1;
        arrScripFields[WATCHLIST_GRID_INDEX.OPTIONTYPE] = eachObj?._source?.sOptionType;
        arrScripFields[WATCHLIST_GRID_INDEX.ASSET_TOKEN] = eachObj?._source?.nAssetToken;
        arrScripFields[WATCHLIST_GRID_INDEX.PRICE_TICK] = (eachObj?._source?.nPriceTick / eachObj?._source?.DecimalLocator);
        arrScripFields[WATCHLIST_GRID_INDEX.REGULAR_LOT] = eachObj?._source?.nRegularLot;
        arrScripFields[WATCHLIST_GRID_INDEX.SECTOR] = eachObj?._source?.sSector;
        arrScripFields[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] = eachObj?._source?.ExchangeSegment;
        arrScripFields[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR] = eachObj?._source?.DecimalLocator;
        arrScripFields[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] = getDynamicParamsForToFixed(eachObj?._source?.ExchangeSegment);
        arrScripFields[WATCHLIST_GRID_INDEX?.EXCHANGE_SEGMENT] = eachObj?._source?.ExchangeSegment;

        //Maaz A : 27-09-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
        arrScripFields[WATCHLIST_GRID_INDEX.IS_FO_EXIST] = eachObj?._source?.nFOExists;
        arrScripFields[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT] = eachObj?._source?.sQtyUnit?.trim() || 'Qty';
        //Maaz A : 27-09-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
        //Vaibhav Singh:16-12-23:BT-107055: ISIN code added fixed: Start
        arrScripFields[WATCHLIST_GRID_INDEX.ISIN_CODE] = eachObj?._source?.sISINCode;
        //Vaibhav Singh:16-12-23:BT-107055: ISIN code added fixed: End
        arrScripFields[WATCHLIST_GRID_INDEX.PRICE_NUMERATOR] = eachObj?._source?.nPriceNum ? eachObj?._source?.nPriceNum : 1;
        arrScripFields[WATCHLIST_GRID_INDEX.PRICE_DENOMINATOR] = eachObj?._source?.nPriceDen ? eachObj?._source?.nPriceDen : 1;
        arrScripFields[WATCHLIST_GRID_INDEX.AVM_BUY_MARGIN] = eachObj?._source?.nAVMBuyMargin ? eachObj?._source?.nAVMBuyMargin : 1;
        arrScripFields[WATCHLIST_GRID_INDEX.AVM_SELL_MARGIN] = eachObj?._source?.nAVMSellMargin ? eachObj?._source?.nAVMSellMargin : 1;
        if (eachObj?._source?.nExpiryDate === 0) {
            arrScripFields[WATCHLIST_GRID_INDEX.SECURITY_DESCRIPTION] = eachObj._source.sSecurityDesc;
            arrScripFields[WATCHLIST_GRID_INDEX.DISPLAY_DESC] = arrScripFields[WATCHLIST_GRID_INDEX.SYMBOL];
            arrScripFields[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] = eachObj?._source?.sSurvMeasureDescription;//BT-106965 : Ordercart : Security Measures Warning : ManasaB : 24-04-2024 
        } else {
            arrScripFields[WATCHLIST_GRID_INDEX.SECURITY_DESCRIPTION] = eachObj._source.sDerivitiveDesc.split("--")[0];
            arrScripFields[WATCHLIST_GRID_INDEX.DISPLAY_DESC] = arrScripFields[WATCHLIST_GRID_INDEX.SYMBOL] + " " + arrScripFields[WATCHLIST_GRID_INDEX.EXPIRYDATE] + " " + arrScripFields[WATCHLIST_GRID_INDEX.STRIKEPRICE] + " " + arrScripFields[WATCHLIST_GRID_INDEX.OPTIONTYPE];
        }
        //By HiralK : 05-08-2023 - To resolve Search Description issue - End
        // BT-114569 : Functional Implementation : Vaibhav Singh : 01-07-2023 : added expirydate to searchscrip needed to show in overview modal
        return arrScripFields;
    });
    return arrSearchData;
};


async function _getSearchAllScrips(sSearchText, nMktAllowed, nPageNo, nTotalNoOfElements) {
    /*_getSearchScrips => it returns scrips which matches with search text */
    /*sSearchText=> it holds the value of whatever we type in input in global search
    nMktAllowed =>  market segment id
    nPageNo => no of scrips per page
     nTotalNoOfElements => total no of scrips to fetch
     */
    try {
        const objScripResp = await getScripLookUp(sSearchText, nMktAllowed, nPageNo, nTotalNoOfElements);
        const arrSearchData = getSearchDataAsPerSearchIndexes(objScripResp);
        //BT-107433 : Calculator : SAT2 ManasaB : 23/03/2023 : BT-115296 Calculator Bug Fixing - Start
        let arrExpiryDates = [];
        const arrFUTResp = objScripResp?.data?.result?.hits?.hits;
        if (arrFUTResp?.length > 0) {
            arrExpiryDates = arrFUTResp?.map(eachObj => {
                return {
                    strDate: eachObj?._source?.nExpiryDate1,
                    nExchangeId: eachObj?._source?.MktSegId
                };
                // arrExpiryDates.push(objDate);
            });
        }
        //BT-107433 : Calculator : SAT2ManasaB : 23/03/2023 : BT-115296 Calculator Bug Fixing - End

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { arrSearchData, objScripResp, expiryDates: arrExpiryDates } };
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
async function _getSearchScrips(strSearchText, nMktAllowed, nPageNo, nTotalNoOfElements, isDefaultAllTab, arrAllPages, isSpanMargin) {

    /*_getSearchScripsAll => it returns scrips which comes under equity */
    /*sSearchText=> it holds the value of whatever we type in input in global search
    nMktAllowed =>  market segment id
    nPageNo => no of scrips per page
     nTotalNoOfElements => total no of scrips to fetch
    */
    try {
        let sSearchText = strSearchText.trim();
        let objOPResp = {};
        let arrOptSearchListingData = [];
        let arrOptionChainDataGlobalSearch = [];
        let arrOptSearchData = [];
        //Vaibhav Singh : 15-11-23: Added Lookup marketallowed in controller as well: Start
        let objLoginSession = JSON.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
        const objEqResp = await getScripLookUp(sSearchText + ' EQUITIES', objLoginSession?.nExchangesViewAllowed ? objLoginSession.nExchangesViewAllowed : nMktAllowed, nPageNo, nTotalNoOfElements);
        const objFUResp = await getScripLookUp(sSearchText + ' FUT', objLoginSession?.nExchangesViewAllowed ? objLoginSession.nExchangesViewAllowed : nMktAllowed, nPageNo, 1000);
        if (isDefaultAllTab || isSpanMargin) {
            objOPResp = await getScripLookUp(sSearchText + ' OPT', objLoginSession?.nExchangesViewAllowed ? objLoginSession.nExchangesViewAllowed : nMktAllowed, nPageNo, nTotalNoOfElements);
            arrOptSearchListingData = getSearchDataAsPerSearchIndexes(objOPResp);
        }
        // else {
        //     objOPResp = await getDistinctExpiry(sSearchText, objLoginSession?.nExchangesViewAllowed ? objLoginSession.nExchangesViewAllowed : nMktAllowed);
        //     arrOptSearchData = objOPResp.data?.result?.aggregations?.optsym?.buckets;
        //     arrOptionChainDataGlobalSearch = objOPResp.data?.result?.hits.hits;
        // }

        const arrEqSearchData = getSearchDataAsPerSearchIndexes(objEqResp);
        const arrFuSearchData = getSearchDataAsPerSearchIndexes(objFUResp);
        // const objScripAllResp = await _getSearchAllScrips(strSearchText, objLoginSession?.nExchangesViewAllowed ? objLoginSession.nExchangesViewAllowed : nMktAllowed, nPageNo, nTotalNoOfElements);
        // const arrSearchData = objScripAllResp.data.arrSearchData;
        // const arrAllCount = objScripAllResp.data.objScripResp.data?.result.hits.total.value;
        //Vaibhav Singh : 15-11-23: Added Lookup marketallowed in controller as well: End
        //BT-114442 : Option tab functionality : ManasaB : 11/08/2023 - Start
        //const arrOptSearchData = getSearchDataAsPerSearchIndexes(objOPResp);

        // const arrOptSearchListingData = objOPResp.data.result.hits.hits;

        const nOptListDataCount = objOPResp?.data?.result?.hits?.total?.value;
        //BT-114442 : Option tab functionality : ManasaB : 11/08/2023 - End
        const objScripPageData = await _getSearchPages(strSearchText, arrAllPages);
        let arrPagesData = [];
        if (objScripPageData.status) {
            if (objScripPageData?.data?.arrSearchedPages && objScripPageData?.data?.arrSearchedPages?.length > 0) {
                arrPagesData = objScripPageData?.data?.arrSearchedPages;
            }
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { arrEqSearchData, arrFuSearchData, objEqResp, objFUResp, arrOptSearchData, arrOptSearchListingData, objOPResp, nOptListDataCount, arrPagesData, arrOptionChainDataGlobalSearch } };

    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };

    }

}
async function _getSearchScripsEquity(strSearchText, nMktAllowed, nPageNo, nTotalNoOfElements) {
    /*_getSearchScripsEquity => it returns scrips which comes under equity */
    /*sSearchText=> it holds the value of whatever we type in input in global search
    nMktAllowed =>  market segment id
    nPageNo => no of scrips per page
     nTotalNoOfElements => total no of scrips to fetch
    */
    try {
        let objLoginSession = JSON.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024  
        let sSearchText = strSearchText.trim();
        const objEqResp = await getScripLookUp(sSearchText + ' EQUITIES', objLoginSession?.nExchangesViewAllowed ? objLoginSession.nExchangesViewAllowed : nMktAllowed, nPageNo, nTotalNoOfElements);//BT-106965 : Ordercart : SAT1 Issues : ManasaB : 02-04-2024 
        const arrSearchData = getSearchDataAsPerSearchIndexes(objEqResp);
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { arrSearchData, objEqResp } };

    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };

    }
}

async function _getSearchScripsMutualFunds(strSearchText, nMktAllowed, nPageNo, nTotalNoOfElements) {
    /*_getSearchScripsMutualFunds => it returns scrips which comes under mutual funds */
    /*sSearchText=> it holds the value of whatever we type in input in global search
    nMktAllowed =>  market segment id
    nPageNo => no of scrips per page
     nTotalNoOfElements => total no of scrips to fetch
    */
    try {
        let sSearchText = strSearchText.trim();
        const objMFResp = await mutualFundSearch({ schemeName: sSearchText, pageNo: nPageNo, pageSize: nTotalNoOfElements });
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { objMFResp: objMFResp.data.data, metadata: objMFResp.data.metadata } };

    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

function _getSearchPages(sSearchText, arrAllPages) {
    /*sSearchText=> it holds the value of whatever we type in input in global search */
    try {
        // const arrAllPages = deepClone(GLOBAL_SEARCH_PAGES);
        let arrSearchedPages = [];
        if (sSearchText) {
            arrSearchedPages = arrAllPages?.filter(page => page?.displayName?.toUpperCase()?.includes(sSearchText?.toUpperCase()));
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { arrSearchedPages } };
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
async function _getSearchScripsFutures(strSearchText, nMktAllowed, nPageNo, nTotalNoOfElements, bCalculateDate = false) {
    /*_getSearchScripsFutures => it returns scrips which comes under future */
    /*sSearchText=> it holds the value of whatever we type in input in global search
    nMktAllowed =>  market segment id
    nPageNo => no of scrips per page
     nTotalNoOfElements => total no of scrips to fetch
    
    */
    try {
        let sSearchText = strSearchText.trim();
        const objFUTScripResp = await getScripLookUp(sSearchText + ' FUT', nMktAllowed, nPageNo, nTotalNoOfElements);
        const arrSearchData = getSearchDataAsPerSearchIndexes(objFUTScripResp);
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { arrSearchData, objFUTScripResp } };
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
async function _getSearchScripsOptions(strSearchText, nMktAllowed, nPageNo, nTotalNoOfElements, bCalculateDate = false) {
    /*_getSearchScripsOptions => it returns scrips which comes under options */
    /*sSearchText=> it holds the value of whatever we type in input in global search
    nMktAllowed =>  market segment id
    nPageNo => no of scrips per page
     nTotalNoOfElements => total no of scrips to fetch
    */
    try {
        let sSearchText = strSearchText.trim();
        // const objOPTScripResp = await getDistinctExpiry(sSearchText, nMktAllowed);
        const objOPTScripResp = await getScripLookUp(sSearchText + ' OPT', nMktAllowed, nPageNo, nTotalNoOfElements);
        const arrSearchData = getSearchDataAsPerSearchIndexes(objOPTScripResp);
        let arrExpiryDates = [];
        if (bCalculateDate) {
            const arrOPTResp = objOPTScripResp?.data?.result?.hits?.hits;
            arrExpiryDates = arrOPTResp?.map(eachObj => {
                return {
                    strDate: eachObj?._source?.nExpiryDate1,
                    nExchangeId: eachObj?._source?.MktSegId,
                    strikePrice: eachObj?._source?.nStrikePrice1
                };
                // arrExpiryDates.push(objDate);
            });
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { arrSearchData, objOPTScripResp: objOPTScripResp?.data, expiryDates: arrExpiryDates } };
        //ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing - End
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
function _scripLimit(nIsExpand) {
    /*nIsExpand -> to know whether it is eglobal search is expand view(10 scrips) or normal view(5 scrips)
    _scripLimit -> returns how many scrips we have to show */
    try {
        if (nIsExpand) {
            var nScripLimit = EXPAND_RECENT_SEARCH_LENGTH;
        }
        else {
            nScripLimit = RECENT_SEARCH_LENGTH;
        }
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: { nScripLimit } };
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
};
function _tabsValidation(objLoginSession, arrEqScrips) {
    // console.log('exchanges',objLoginSession.data.exchanges)
    try {

        // console.log("firstCondition",objLoginSession?.data?.exchanges && objLoginSession?.data?.exchanges?.length > 0 &&  objLoginSession?.data?.exchanges.some(exchange => exchange.includes('EQ')) && GLOBAL_SEARCH_SCRIPS.TOTAL_EQ_SCRIPS !== 0)


        // console.log("second",objLoginSession?.data?.exchanges && objLoginSession?.data?.exchanges?.length > 0 && objLoginSession?.data?.exchanges.some(exchange => exchange.includes('FO')) && GLOBAL_SEARCH_SCRIPS.TOTAL_FUT_SCRIPS !== 0&& GLOBAL_SEARCH_SCRIPS.TOTAL_OPT_SCRIPS !== 0)


        // console.log("third",objLoginSession?.data?.exchanges && objLoginSession?.data?.exchanges?.length > 0 && objLoginSession?.data?.exchanges.some(exchange => exchange.includes('FO')) && GLOBAL_SEARCH_SCRIPS.TOTAL_OPT_SCRIPS !== 0)


        if (objLoginSession?.data?.exchanges && objLoginSession?.data?.exchanges?.length > 0 && objLoginSession?.data?.exchanges.some(exchange => exchange.includes('EQ')) && GLOBAL_SEARCH_SCRIPS.TOTAL_EQ_SCRIPS !== 0) {
            return { status: true, message: 'SUCCESS', data: { equity: true, future: false, option: false } };

        }
        else if (objLoginSession?.data?.exchanges && objLoginSession?.data?.exchanges?.length > 0 && objLoginSession?.data?.exchanges.some(exchange => exchange.includes('FO')) && GLOBAL_SEARCH_SCRIPS.TOTAL_FUT_SCRIPS !== 0 && GLOBAL_SEARCH_SCRIPS.TOTAL_OPT_SCRIPS !== 0) {
            return { status: true, message: 'SUCCESS', data: { equity: false, future: true, option: false } };
        }
        else if (objLoginSession?.data?.exchanges && objLoginSession?.data?.exchanges?.length > 0 && objLoginSession?.data?.exchanges.some(exchange => exchange.includes('FO')) && GLOBAL_SEARCH_SCRIPS.TOTAL_OPT_SCRIPS !== 0) {
            return { status: true, message: 'SUCCESS', data: { equity: false, future: false, option: true } };
        }
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
//As per PR comments added to redux state : Manasa B : 28/08/2023 - Start
function _getFilteredRecommendationScrips(sSearchText, arrRecommendations) {
    try {
        const arrRecoScrips = arrRecommendations.filter(eachReco => eachReco?.companyName?.includes(sSearchText.toUpperCase()));
        return { status: true, message: 'SUCCESS', data: { arrRecoScrips } };
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
function _getFilteredAlertScrips(sSearchText, arrAlerts) {
    try {
        const arrSearchAlertScrips = arrAlerts.filter(eachAlert => eachAlert.symbol?.includes(sSearchText?.toUpperCase()));
        return { status: true, message: 'SUCCESS', data: { arrSearchAlertScrips } };
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
function _getFilteredEventScrips(sSearchText, arrEvents) {
    try {
        if (arrEvents && arrEvents?.length > 0) {
            const arrAllEvents = arrEvents[0]?.data;
            const arrSearchEventScrips = arrAllEvents?.filter(eachEvent => eachEvent?.title?.toUpperCase().includes(sSearchText.toUpperCase()) || eachEvent.description?.includes(sSearchText.toUpperCase()));
            return { status: true, message: 'SUCCESS', data: { arrSearchEventScrips } };
        }
        else {
            return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE };
        }

    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
function _getFilteredIPOScrips(sSearchText, arrIPO) {
    try {
        const arrSearchIPOScrips = arrIPO.filter(eachIpo => eachIpo.OfferName.toUpperCase().includes(sSearchText.toUpperCase()));
        return { status: true, message: 'SUCCESS', data: { arrSearchIPOScrips } };
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
function _getFilteredNewsScrips(sSearchText, arrNews) {
    try {
        const arrSearchNewsScrips = arrNews?.filter(eachNews => eachNews.symbol === sSearchText.toUpperCase() || eachNews.news_content.toUpperCase().includes(sSearchText.toUpperCase()));
        return { status: true, message: 'SUCCESS', data: { arrSearchNewsScrips } };
    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}
//As per PR comments added to redux state : Manasa B : 28/08/2023 - End
export {
    _getSearchScripsEquity, _getSearchPages, _getSearchAllScrips, _getSearchScripsFutures,
    _getSearchScripsOptions, _scripLimit, _tabsValidation, _getSearchScrips, _getFilteredRecommendationScrips,
    _getFilteredAlertScrips, _getFilteredEventScrips, _getFilteredIPOScrips, _getFilteredNewsScrips, _getSearchScripsMutualFunds, getSearchDataAsPerSearchIndexes
};
